import type { Lang } from '../types';

export interface NotFoundText {
  heading: string;
  description: string;
  goBack: string;
  goHome: string;
}

export const notFoundText: Record<Lang, NotFoundText> = {
  cs: {
    heading: 'Stránka nenalezena',
    description: 'Stránka, kterou hledáte, neexistuje nebo byla přesunuta.',
    goBack: 'Zpět',
    goHome: 'Na úvod',
  },
  en: {
    heading: 'Page not found',
    description: "The page you're looking for doesn't exist or has been moved.",
    goBack: 'Go back',
    goHome: 'Go to home',
  },
  vi: {
    heading: 'Không tìm thấy trang',
    description: 'Trang bạn đang tìm không tồn tại hoặc đã bị di chuyển.',
    goBack: 'Quay lại',
    goHome: 'Về trang chủ',
  },
  uk: {
    heading: 'Сторінку не знайдено',
    description: 'Сторінка, яку ви шукаєте, не існує або була переміщена.',
    goBack: 'Назад',
    goHome: 'На головну',
  },
};
